import "./widgets-core7.css";
import { defineComponent as p, useCssVars as _, unref as r, ref as h, openBlock as l, createElementBlock as d, withModifiers as w, createVNode as s, Transition as v, withCtx as i, mergeProps as C, createElementVNode as b, renderSlot as g, createCommentVNode as k } from "vue";
import { o as x } from "./chunks/index.CIpUD9Rm.js";
import y from "./widgets-core.es11.js";
import A from "./widgets-core.es20.js";
import { u as $ } from "./chunks/useTheme.L4REnSCw.js";
import { _ as B } from "./chunks/_plugin-vue_export-helper.CHgC5LLL.js";
const E = { class: "thn-widget-modal__content" }, V = {
  key: 0,
  class: "thn-widget-modal__close"
}, W = /* @__PURE__ */ p({
  inheritAttrs: !1,
  __name: "Modal",
  props: {
    showClose: { type: Boolean, default: !0 },
    zIndex: { default: 50 }
  },
  emits: [
    "close"
  ],
  setup(c, { emit: m }) {
    _((t) => ({
      "270bf978": a.zIndex,
      "6916ad25": r(n).borderRadius
    }));
    const a = c, u = m, e = h(null), n = $();
    function o() {
      u("close");
    }
    function f() {
      e.value && (e.value.$el.setAttribute("tabindex", "0"), e.value.$el.focus());
    }
    return x("Escape", () => {
      o();
    }), (t, I) => (l(), d("div", {
      class: "thn-widget-modal",
      tabindex: "-1",
      onClick: w(o, ["self"])
    }, [
      s(v, {
        name: "slide-up",
        onAfterEnter: f,
        appear: ""
      }, {
        default: i(() => [
          s(y, C({
            ref_key: "modalWindow",
            ref: e
          }, t.$attrs, {
            class: [
              "thn-widget-modal__window",
              t.$attrs.class
            ],
            tabindex: "0",
            role: "dialog"
          }), {
            default: i(() => [
              b("div", E, [
                g(t.$slots, "default", { close: o }, void 0, !0)
              ]),
              a.showClose ? (l(), d("div", V, [
                s(A, {
                  type: "close",
                  "over-color": r(n).backgroundColor.base,
                  onActionClick: o,
                  "data-testid": "close-modal"
                }, null, 8, ["over-color"])
              ])) : k("", !0)
            ]),
            _: 3
          }, 16, ["class"])
        ]),
        _: 3
      })
    ]));
  }
}), P = /* @__PURE__ */ B(W, [["__scopeId", "data-v-972863e0"]]);
export {
  P as default
};
//# sourceMappingURL=widgets-core.es9.js.map
